import React, { PureComponent } from 'react';
import SearchResults from './SearchResults';
import { BASE_URL } from '../config';

export default class SearchDrawer extends PureComponent {
  state = {
    searchString: '',
    components: [],
  }

  filterChange = () => {
    this.setState({ searchString: this.searchInput.value });
  }

  componentDidMount() {
    fetch(`${BASE_URL}/spa_data/components_page.json`)
      .then(result => result.json())
      .then((json) => {
        this.setState({
          components: json,
        });
      });
  }

  searchResults = () => {
    const { components, searchString } = this.state;

    if (!searchString.length) return null;

    const matchingComponents = components.filter(
      c => (
        c.name.indexOf(searchString) >= 0 ||
        (c.description && c.description.indexOf(searchString) >= 0)
      )
    ).slice(0, 10);

    return (
      <SearchResults
        matchingComponents={matchingComponents}
        onResultClicked={this.props.onResultClicked}
      />
    );
  }

  render() {
    return (
      <div>
        <input
          type="text"
          placeholder="Component search..."
          onKeyUp={this.filterChange}
          ref={el => {
            this.searchInput = el;
            if (this.props.onSearchInputRef) {
              this.props.onSearchInputRef(el);
            }
          }}
          style={{
            border: 'none',
            display: 'block',
            fontSize: 24,
            fontWeight: 200,
            marginTop: -4,
            outline: 'none',
            padding: '0 0 0 8',
          }}
        />
        { this.searchResults() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchDrawer.jsx